module.exports = __webpack_public_path__ + "img/company_logo1.edef7f0c.jpg";